(function () {
  // Domyślny tytuł strony
  var originalTitle = document.title;

  // Lista tłumaczeń dla komunikatu "Wróć do nas 😍 Minoti.com"
  var awayTitles = {
    "pl": "Wróć do nas 😍 Minoti.com",
    "en": "Come back to us 😍 Minoti.com",
    "de": "Komm zurück zu uns 😍 Minoti.com",
    "fr": "Revenez chez nous 😍 Minoti.com",
    "es": "Vuelve con nosotros 😍 Minoti.com",
    "it": "Torna da noi 😍 Minoti.com",
    "cs": "Vrať se k nám 😍 Minoti.com",
    "sk": "Vráť sa k nám 😍 Minoti.com",
    "hu": "Gyere vissza hozzánk 😍 Minoti.com",
    "ro": "Întoarce-te la noi 😍 Minoti.com",
    "nl": "Kom terug bij ons 😍 Minoti.com",
    "sv": "Kom tillbaka till oss 😍 Minoti.com"
  };

  // Wykryj język użytkownika
  var userLang = navigator.language.slice(0, 2);
  var awayTitle = awayTitles[userLang] || awayTitles["en"]; // domyślnie angielski

  // Obserwuj zmiany tytułu (np. na stronach produktu)
  var titleObserver = new MutationObserver(function () {
    if (!document.hidden) originalTitle = document.title;
  });
  titleObserver.observe(document.querySelector('title'), { childList: true });

  // Aktualizacja tytułu w zależności od widoczności strony
  function updateTitle() {
    document.title = document.hidden ? awayTitle : originalTitle;
  }

  document.addEventListener('visibilitychange', updateTitle, false);
  window.addEventListener('focus', updateTitle, false);
  window.addEventListener('blur', updateTitle, false);
})();
